<template>
  <main class="main community community_detail" role="main" v-if="isCompleted">
    <div class="main_con">
      <div class="header_btn">
        <!-- <i class="i_share" @click="shareIntent"></i> -->
        <i
          v-if="knowhow.isMine === 'Y'"
          class="i_h_more"
          @click="openBottomModal('POST_EDIT')"
        ></i>
      </div>
      <!-- 질문 영역-->
      <SectionQuestion
        :board-type="boardType"
        :data="knowhow"
        @report="openBottomModal"
        @like="fnLike"
      />

      <!-- 답변 영역 -->
      <article class="anwser_area" v-if="answerList.length > 0">
        <SectionAnwser
          :board-type="boardType"
          :list="answerList"
          :user-id="knowhow.userId"
          @more="openBottomModal"
          @like="fnLike"
          @chat="enterChatRoom"
          @reply="openComment"
          v-if="isAnswerList"
        />
      </article>
      <article v-else>
        <div class="empty_wrap">
          <div class="empty">
            <div class="msg">
              <div>등록된 답변이 없습니다</div>
            </div>
          </div>
        </div>
      </article>

      <!-- 댓글 등록 영역-->
      <InputComment
        v-show="isCommentOn"
        ref="InputComment"
        :selected-comment="selectedComment"
        @submit="submitComment"
        @close="resetComment"
      />
    </div>
    <BottomModal
      :show="isBottomModal"
      :mode="mode"
      @report="openReportModal"
      @post-edit="fnEditPost"
      @comme-edit="fnEditComme"
      @close="closeBottomModal"
    />
    <ReportModal :show="isReportModal" @close="closeReportModal" />
    <DesignPopup :show="openDesignPopup" :data="popupParams" @close="confirm" />
  </main>
</template>

<script>
import {
  mapActions as communityMapActions,
  mapGetters as communityGetters,
} from '@common/store/modules/community';
import * as communityTypes from '@common/store/modules/community/types';

import {
  mapActions as chatMapActions,
  mapGetters as chatMapGetters,
} from '@common/store/modules/chat';
import * as chatActions from '@common/store/modules/chat/types';
import * as chatGetters from '@common/store/modules/chat/getters';

import SectionQuestion from '@common/components/community/detail/SectionQuestion';
import SectionAnwser from '@common/components/community/detail/SectionAnwser';
import InputComment from '@common/components/community/detail/InputComment';

import BottomModal from '@common/components/community/modal/BottomModal';
import ReportModal from '@common/components/community/modal/ReportModal';
import DesignPopup from '@/common/components/modal/DesignPopup.vue';

import { isApp, nativeShareText } from '@common/lib/common/utils';

export default {
  name: 'community-knowhow-detail',
  description: '커뮤니티 > 사용자 지식인 상세',
  components: {
    SectionQuestion,
    SectionAnwser,
    InputComment,
    BottomModal,
    ReportModal,
    DesignPopup,
  },
  data() {
    return {
      boardType: 'KNOWHOW',
      mode: '',
      params: {
        boardId: this.$route.params.id,
        isRead: this.$route.params.isRead || 'N',
        page: 1,
        size: 100,
      },
      isBottomModal: false,
      isReportModal: false,
      selectedComment: '',
      openDesignPopup: false,
      popupParams: {},
      popupMode: '',
      modalVal: {}, // 선택된 댓글 데이터
      modalIndex: 0,
      isCommentOn: false,
      isCompleted: false,
      isAnswerList: false,
    };
  },
  async created() {
    await this[communityTypes.FETCH_KNOWHOW]({
      id: this.params.boardId,
      isRead: this.params.isRead,
    });
    await this.getAnswerList();
    this.$nextTick(() => {
      this.isCompleted = true;
    });
  },
  computed: {
    ...communityGetters({
      knowhow: communityTypes.FETCH_KNOWHOW,
      answerList: communityTypes.FETCH_KNOWHOW_ANSWER_LIST,
    }),
    ...chatMapGetters({
      chatroom_with: chatGetters.CHATROOMS_WITH,
      chatroom: chatGetters.CHATROOM,
    }),
  },
  methods: {
    ...communityMapActions([
      communityTypes.FETCH_KNOWHOW,
      communityTypes.LIKE_KNOWHOW,
      communityTypes.UNLIKE_KNOWHOW,
      communityTypes.DELETE_KNOWHOW,
      communityTypes.REPORT_KNOWHOW,
      communityTypes.FETCH_KNOWHOW_ANSWER_LIST,
      communityTypes.CREATE_KNOWHOW_REPLY,
      communityTypes.UPDATE_KNOWHOW_REPLY,
      communityTypes.DELETE_KNOWHOW_REPLY,
      communityTypes.LIKE_KNOWHOW_REPLY,
      communityTypes.UNLIKE_KNOWHOW_REPLY,
      communityTypes.REPORT_KNOWHOW_REPLY,
      communityTypes.REPORT_USER,
    ]),
    ...chatMapActions([
      chatActions.FETCH_CHATROOM_WITH_STORE,
      chatActions.CHATROOMS_WITH_RESET_STATE,
      chatActions.CREATE_CHATROOM,
    ]),
    async getAnswerList() {
      this[communityTypes.FETCH_KNOWHOW_ANSWER_LIST]({
        id: this.params.boardId,
      }).then(() => {
        this.isAnswerList = true;
        console.log('this.answerList');
        console.log(this.answerList);
      });
    },
    openBottomModal(mode, val) {
      this.isBottomModal = true;
      this.mode = mode;
      this.modalVal = val;
    },
    closeBottomModal() {
      this.isBottomModal = false;
    },
    fnEditPost(val) {
      if (val === 'MODIFY') {
        this.$router.push({
          name: 'Knowhow.Write',
          query: { boardId: this.params.boardId },
        });
      } else {
        this.popupParams = {
          type: 'confirm',
          msg: '게시글을 삭제 하시겠습니까?',
        };
        this.popupMode = 'POST_DELETE';
        this.openDesignPopup = true;
      }
    },
    fnEditComme(val) {
      if (val === 'MODIFY') {
        this.closeBottomModal();
        this.isCommentOn = true;
        this.$refs.InputComment.form = { content: this.modalVal.contents };
        this.$nextTick(() => {
          const textarea = this.$refs.InputComment.$refs.textarea;
          textarea.style.height = 'auto';
          textarea.style.height = textarea.scrollHeight + 'px';
          textarea.focus();
        });
      } else {
        this.popupParams = {
          type: 'confirm',
          msg: '답글을 삭제 하시겠습니까?',
        };
        this.popupMode = 'COMME_DELETE';
        this.openDesignPopup = true;
      }
    },
    confirm(isSave) {
      if (isSave) {
        if (this.popupMode === 'POST_DELETE') {
          this[communityTypes.DELETE_KNOWHOW]({ id: this.params.boardId });
        } else {
          this[communityTypes.DELETE_KNOWHOW_REPLY]({ id: this.modalVal.id });
        }
        this.popupParams = { type: 'alert', msg: '삭제되었습니다' };
      } else {
        this.openDesignPopup = false;
        if (this.popupParams.type === 'alert') {
          if (this.popupMode === 'POST_DELETE') {
            this.$router.go(-1);
          } else {
            this.closeBottomModal();
            this.getAnswerList();
          }
        }
        this.popupMode = '';
      }
    },
    openReportModal(val) {
      this.popupMode = val;
      this.closeBottomModal();
      this.isReportModal = true;
    },
    closeReportModal(reason) {
      if (reason) {
        let params = { id: this.modalVal.id, reason: reason };
        if (this.popupMode === 'REPORT_POST') {
          this[communityTypes.REPORT_KNOWHOW](params);
        } else if (this.popupMode === 'REPORT_COMME') {
          this[communityTypes.REPORT_KNOWHOW_REPLY](params);
        } else if (this.popupMode === 'REPORT_USER') {
          params.id = this.modalVal.userId;
          this[communityTypes.REPORT_USER](params);
        }
        this.openDesignPopup = true;
        this.popupParams = { type: 'alert', msg: '신고되었습니다' };
        this.popupMode = '';
      }
      this.isReportModal = false;
    },
    openComment(item) {
      this.$refs.InputComment.form.content = '';
      this.isCommentOn = true;
      this.selectedComment = { ...item, writer: item.answerStore.storeName };
      this.$nextTick(() => {
        const textarea = this.$refs.InputComment.$refs.textarea;
        textarea.style.height = '3.9rem';
        textarea.focus();
      });
    },
    async submitComment(form) {
      let params = { content: form.content };
      if (form.boardId) {
        params.isAnonymous = 'N';
        params.boardId = this.selectedComment.id;
        await this[communityTypes.CREATE_KNOWHOW_REPLY](params);
      } else {
        params.id = this.modalVal.id;
        await this[communityTypes.UPDATE_KNOWHOW_REPLY](params);
      }
      await this.getAnswerList();
      await this.resetComment();
      this.modalVal = {};
    },
    resetComment() {
      this.isCommentOn = false;
      this.commentMode = 'CREATE';
      this.selectedComment = '';
      this.$refs.InputComment.form.content = '';
    },
    fnLike(item, type) {
      if (item.isLike === 'Y') {
        item.isLike = 'N';
        item.likeCnt--;
        if (type === 'COMMENT') {
          // 답글
          this[communityTypes.UNLIKE_KNOWHOW_REPLY]({ id: item.id });
        } else {
          // 게시글, 답변
          this[communityTypes.UNLIKE_KNOWHOW]({ id: item.id });
        }
      } else {
        item.isLike = 'Y';
        item.likeCnt++;
        if (type === 'COMMENT') {
          // 답글
          this[communityTypes.LIKE_KNOWHOW_REPLY]({ id: item.id });
        } else {
          // 게시글, 답변
          this[communityTypes.LIKE_KNOWHOW]({ id: item.id });
        }
      }
    },
    async enterChatRoom(item) {
      this[chatActions.CHATROOMS_WITH_RESET_STATE]();
      await this[chatActions.FETCH_CHATROOM_WITH_STORE]({
        chatRoomType: 'OneOnOne',
        storeId: item.storeId,
      });
      let name = 'chat.room';
      const params = {};
      if (this.chatroom_with.count == 0) {
        this[chatActions.CREATE_CHATROOM]({
          chatRoomType: 'OneOnOne',
          memberId: '',
          storeId: item.storeId,
          estimateId: undefined,
        }).then(() => {
          params.uuid = this.chatroom.uuid;
          this.$router.push({ name, params });
        });
      } else {
        params.uuid = this.chatroom_with.content[0].uuid;
        this.$router.push({ name, params });
      }
    },
    async shareIntent() {
      let url = 'https://customer.perse.kr';
      const path = this.$route.fullPath;
      if (process.env.NODE_ENV === 'production') {
        url = 'https://customer.perce.co.kr';
      }
      if (!isApp()) {
        const shareData = {
          title: '퍼스',
          text: '퍼스 다운로드',
          url: url + path,
        };
        await navigator.share(shareData);
      } else {
        nativeShareText(`퍼스 ${url + path}`);
      }
    },
  },
};
</script>

<style></style>
